module.exports = "https://cdn.ticketswap.com/_next/static/images/sports-14ee607601dd27d9325b25ef3bfae616.jpg";